// extracted by mini-css-extract-plugin
export default {"tabButton":"HVaQRJ2ni63XS+Ci8+14TMruWOFV13TUPy+NDryYktA="};